// extracted by mini-css-extract-plugin
module.exports = {"pagination":"I-z7","item":"I-at","active":"I-s3","prevNextWrapper":"I-z9","next":"I-z-","prevNext":"I-ag5","firstLast":"I-ag7","wide":"I-oj","arrow":"I-qn","right":"I-fz"};